module.exports = ".page-navigation {\n  margin-top: 12px;\n  text-align: center;\n  overflow: hidden; }\n  .page-navigation .page-count, .page-navigation .page-button {\n    display: inline-block;\n    vertical-align: middle;\n    height: 40px;\n    line-height: 40px; }\n  .page-navigation .page-button {\n    width: 40px; }\n  .page-navigation .page-count {\n    font-size: 17px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/page-navigation.component.scss
// module id = ./src/app/shared/page-navigation.component.scss
// module chunks = main